import {
  SET_EXPERIMENT,
  UPDATE_APPLE_PAY_AVAILABLE,
  UPDATE_GOOGLE_PAY_AVAILABLE,
  SET_OPTIMIZELY_EXPERIMENT,
  API_CALL,
} from './actionConstants'
import { getExperimentValue } from 'lib/optimize'
import noop from 'lib/noop'
import { OptimizelyClientSideExperiments, OptimizelyServerSideExperiments, activateOptimizelyExperiment } from 'lib/optimizely'
import { AppDispatch } from '../store'
import { FETCH_MERCHANT_FEE_CONFIG } from './apiActionConstants'
import { getMerchantFeeConfig } from 'api/payment'

export function getExperiment(experimentID: string) {
  return (dispatch) => {
    getExperimentValue(experimentID).then(value => dispatch({
      type: SET_EXPERIMENT,
      value,
      experimentID,
    }),
    ).catch(noop)
  }
}

export function setServerExperimentValue(experimentID: string, value: string) {
  return (dispatch) => {
    dispatch({
      type: SET_EXPERIMENT,
      value,
      experimentID,
    })
  }
}

export function updateCanPayWithApplePay(flag: boolean) {
  return {
    type: UPDATE_APPLE_PAY_AVAILABLE,
    value: flag,
  }
}

export function updateCanPayWithGooglePay(flag: boolean) {
  return {
    type: UPDATE_GOOGLE_PAY_AVAILABLE,
    value: flag,
  }
}

export function setOptimizelyExperiment(flagKey: OptimizelyClientSideExperiments | OptimizelyServerSideExperiments) {
  return (dispatch, getState) => {
    const state = getState() as App.State
    const experimentValues = activateOptimizelyExperiment(flagKey)

    if (!state.config.optimizelyExperiments[flagKey]) {
      dispatch({
        type: SET_OPTIMIZELY_EXPERIMENT,
        flagKey,
        value: experimentValues,
      })
    }
  }
}

export function fetchMerchantFeeConfig() {
  return function(dispatch: AppDispatch, getState: () => App.State) {
    const { config } = getState()
    if (config.merchantFeeConfigs.length !== 0) return

    dispatch({
      type: API_CALL,
      api: FETCH_MERCHANT_FEE_CONFIG,
      request: () => getMerchantFeeConfig(),
    })
  }
}
